import { render, staticRenderFns } from "./UserTransfer.vue?vue&type=template&id=81273f18"
import script from "./UserTransfer.vue?vue&type=script&lang=js"
export * from "./UserTransfer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports